import React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import TipsAndUpdatesOutlinedIcon from '@mui/icons-material/TipsAndUpdatesOutlined';

export default function Tip({ text, icon, title, sx = {}, color = '#1E0040' }) {
  return (
    <Stack
      direction='column'
      spacing={1}
      sx={{
        width: '100%',
        padding: '10px 12px',
        background: color,
        borderRadius: 1,
        ...sx,
      }}>
      {(title || icon) && (
        <Stack direction='row' alignItems='center' spacing={0.5}>
          {icon || (
            <TipsAndUpdatesOutlinedIcon sx={{ color: '#fff', height: 18 }} />
          )}
          <Box
            sx={{
              color: '#f2f2fb',
              fontSize: 16,
              fontWeight: 600,
            }}>
            {title ?? 'Tip'}
          </Box>
        </Stack>
      )}
      {text && (
        <Box sx={{ fontSize: 14, color: '#f2f2fb', lineHeight: 1.3 }}>
          {text}
        </Box>
      )}
    </Stack>
  );
}
